import React from "react";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";

import CoachResultsHero from "./components/CoachResultsHero";
import CoachResultsFilters from "./components/CoachResultsFilters";
import CoachResultsTable from "./components/CoachResultsTable";
import EditCoachResultDrawer from "./components/EditCoachResultDrawer";
import ResultsSkeleton from "./components/ResultsSkeleton";
import ResultsEmptyState from "./components/ResultsEmptyState";
import ImagePreviewModal from "./components/ImagePreviewModal";

import { useGroupResultsPage } from "./hooks/useGroupResultsPage";

function GroupResultsPage() {
  useScrollToTop();

  const {
    groups,
    approvedAdherents,
    results,
    filteredResults,
    filters,
    stats,
    loading,
    refreshing,
    savingKey,
    selectedResult,
    form,
    isEditOpen,
    imagePreview,
    fetchResults,
    updateFilters,
    resetFilters,
    openEditResult,
    closeEditResult,
    updateFormField,
    submitEditResult,
    openImagePreview,
    closeImagePreview,
  } = useGroupResultsPage();

  const hasFilters = Boolean(
    filters.search ||
    filters.adherentId ||
    filters.groupId ||
    filters.eventTitle ||
    filters.status !== "all",
  );

  return (
    <main className="min-h-screen bg-slate-50 pb-24 text-slate-950 dark:bg-slate-950 dark:text-white">
      <CoachResultsHero
        stats={stats}
        refreshing={refreshing}
        onRefresh={() => fetchResults({ silent: false })}
      />

      <section className="relative z-20 mx-auto -mt-12 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <CoachResultsFilters
          groups={groups}
          approvedAdherents={approvedAdherents}
          results={results}
          filters={filters}
          onChange={updateFilters}
          onReset={resetFilters}
        />
      </section>

      <section className="relative z-10 mx-auto mt-6 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        {loading ? (
          <ResultsSkeleton />
        ) : filteredResults.length > 0 ? (
          <CoachResultsTable
            results={filteredResults}
            savingKey={savingKey}
            onEdit={openEditResult}
            onOpenImage={openImagePreview}
          />
        ) : (
          <ResultsEmptyState hasFilters={hasFilters} onReset={resetFilters} />
        )}
      </section>

      <EditCoachResultDrawer
        isOpen={isEditOpen}
        result={selectedResult}
        form={form}
        saving={savingKey === "edit-result"}
        onClose={closeEditResult}
        onChange={updateFormField}
        onSubmit={submitEditResult}
      />

      <ImagePreviewModal src={imagePreview} onClose={closeImagePreview} />

      <DashboardNavigation />
      <ScrollIndicator />
    </main>
  );
}

export default GroupResultsPage;
